import { createContext } from 'react';

import { UserModel } from 'lib/models/user.model';

export const CurrentUserContext = createContext<UserModel | null>(null);
